import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TableSectionComponent } from './../../../layout/sections/table-section/table-section.component';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SectionTableFilter } from 'src/app/models/section-table-filter';
import { ParametersComponent } from '../parameters/parameters.component';
import { ReportDetails } from '../report-details';
import { ReportService } from '../report.service';
import { ExportOptions } from '../export-options';
import { ReportParameterDataType } from '../report-parameter';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import { ModuleButton } from 'src/app/models/module-structure';
import { LayoutService } from 'src/app/layout/layout.service';
import { CellValueChangedArgs } from 'src/app/layout/cell-value-changed-args';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface GeneratedReportResponse {
  FileContent: string;
  IsBase64?: boolean;
  IsError?: boolean;
  Message?: string;
}

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.less'],
})
export class ViewerComponent implements OnInit {
  @Input() reportParameters: ParametersComponent;
  @ViewChild('tableSection') tableSection: TableSectionComponent;
  @ViewChild('pdfAutoExportIframe') pdfAutoExportIframe: ElementRef<
    HTMLIFrameElement
  >;

  reportDetails: ReportDetails;
  reportIdVal: number;
  reportButton: ModuleButton[];

  tableName = 'report-table';
  guid = '';
  isTableLoading = false;
  isLoading = false;
  switchValue = true;
  dataTable: { name: string; dataset: any[] } = {
    dataset: [],
    name: '',
  };
  totalRecords = 0;
  dataRetrieverCounter = 0;
  exportOptions: ExportOptions;
  urlToShowInIframe: string;
  htmlToShowInIframe = '';
  @Input() set reportId(val: number) {
    if (this.reportIdVal !== val) {
      this.reportIdVal = val;
      this.init();
    }
  }
  get reportId(): number {
    return this.reportIdVal;
  }

  private destroy$ = new Subject<void>();

  constructor(
    private reportService: ReportService,
    private layoutService: LayoutService,
    private messageService: NzMessageService,
    private activatedRoute: ActivatedRoute,
  ) {
    /*layoutService.cellValueChanged.subscribe((args: CellValueChangedArgs) => {
      const idColName = Object.keys(this.dataTable.dataset[args.row]).find(
        (c) => c.startsWith('Sorting_')
      );
      reportService
        .UpdateFieldValue(
          this.dataTable.dataset[args.row][idColName],
          this.guid,
          args.column.Name,
          this.dataTable.dataset[args.row][args.column.Name]
        )
        .subscribe((d) => {
          console.log(d);
        });
    });*/
  }

  ngOnInit(): void {
    this.layoutService.cellValueChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe((args: CellValueChangedArgs) => {
        const idColName = Object.keys(this.dataTable.dataset[args.row]).find(
          (c) => c.startsWith('Sorting_'),
        );

        this.reportService
          .UpdateFieldValue(
            this.dataTable.dataset[args.row][idColName],
            this.guid,
            args.column.Name,
            this.dataTable.dataset[args.row][args.column.Name],
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe((d) => {
            console.log(d);
          });
      });

    const savedExportOptions = localStorage.getItem(
      'exportOptionsOfReport_' + this.reportId,
    );
    if (savedExportOptions === '' || savedExportOptions === null) {
      this.exportOptions = {
        logo: true,
        description: true,
        parameters: true,
        visible: false,
        exportType: '',
        delimiter: ',',
      };
    } else {
      this.exportOptions = JSON.parse(savedExportOptions);
      this.exportOptions.visible = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  init() {
    this.isLoading = true;
    this.dataTable = { name: this.tableName, dataset: [] };
    this.reportService
      .getReportDetails(this.reportId)
      .subscribe(
        (d: { layoutDefinition: ReportDetails; buttons: ModuleButton[] }) => {
          this.reportDetails = d.layoutDefinition;
          this.reportButton = d.buttons;
          this.isLoading = false;
        },
      );
  }

  pageIndexChanged(index: number) {
    this.loadData(false);
  }

  pageSizeChanged(size: number) {
    this.loadData(false);
  }

  filterChanged() {
    this.loadData(true);
  }

  openExportDrawer(type: string) {
    this.exportOptions.exportType = type;
    this.exportOptions.visible = true;
  }

  export(type: string) {
    this.urlToShowInIframe = '';
    this.htmlToShowInIframe = '';
    this.exportOptions.exportType = type;
    localStorage.setItem(
      'exportOptionsOfReport_' + this.reportId,
      JSON.stringify(this.exportOptions),
    );

    this.isTableLoading = true;
    const parametersToSend = this.getParametersToSend();
    this.reportService
      .exportReport(
        this.reportId,
        this.guid,
        this.exportOptions,
        parametersToSend,
      )
      .subscribe(
        (
          data:
            | { IsError: boolean; Message: string; FileContent: string }
            | any,
        ) => {
          if (data.IsError) {
            this.messageService.error(data.Message);

            this.isTableLoading = false;
            this.exportOptions.visible = false;
          } else {
            if (type === 'pdf' || type === 'PdfHTML') {
              this.downloadFileThroughRequest(data, type);

              this.messageService.warning(
                'Generating PDF file might take a little while, you continue working while pdf is generating.',
              );
            } else {
              this.downloadFile(data.FileContent, type);
            }
          }

          this.isTableLoading = false;
          this.exportOptions.visible = false;
        },
      );
  }

  downloadFileThroughRequest(data: string, type: string) {
    const component = this;
    let intevalCount = 0;
    const interval = setInterval(() => {
      if (component == null) {
        clearInterval(interval);
      }

      component.reportService.getExportedReport(data).subscribe((d: any) => {
        if (d === false) {
          intevalCount = intevalCount + 1;
          if (intevalCount === 10) {
            this.messageService.info(
              'PDF file is generating in the background.',
            );
            intevalCount = 0;
          }
          return;
        } else {
          clearInterval(interval);
          if (d.IsError) {
            this.messageService.error(d.Message || 'Failed to generate report.');
            return;
          }

          this.downloadGeneratedReport(d, type);
        }
      });
    }, 3000);
  }

  downloadGeneratedReport(data: GeneratedReportResponse, type: string) {
    const isBase64 = data.IsBase64 !== false;
    if (isBase64) {
      this.downloadFile(data.FileContent, type);
      return;
    }

    this.openHtmlReport(data.FileContent);
  }

  downloadFile(data: string, type: string) {
    let mimeType = '';
    let extension = '';
    if (type === 'excel') {
      mimeType = 'application/vnd.ms-excel';
      extension = 'xlsx';
    } else if (type === 'csv') {
      mimeType = 'text/csv';
      extension = 'csv';
    } else if (type === 'pdf' || type === 'PdfHTML') {
      mimeType = 'application/pdf';
      extension = 'pdf';
    }

    let dataToDownload: Blob;
    if (type === 'csv') {
      const blob = new Blob([data], {
        type: mimeType,
      });
      dataToDownload = blob;
    } else {
      const blob = new Blob([this.base64ToArray(data)], {
        type: mimeType,
      });
      dataToDownload = blob;
    }

    const url = window.URL.createObjectURL(dataToDownload);
    const anchor = document.createElement('a');
    anchor.download = `${this.reportDetails.Description}_${moment().format(
      'YYYYMMDD_hhmm',
    )}.${extension}`;

    if (this.reportDetails.AutoExportPDF) {
      if (
        this.activatedRoute.snapshot.queryParams['openPdfDirectly'] == 'true'
      ) {
        const newWindow = window.open(url);
        if (newWindow) {
          newWindow.print();
        }
        //newWindow.close();
      } else {
        this.urlToShowInIframe = url;
      }
    } else {
      anchor.href = url;
      anchor.click();
      anchor.remove();
    }
  }

  openHtmlReport(html: string) {
    this.urlToShowInIframe = '';
    this.htmlToShowInIframe = html;

    setTimeout(() => {
      this.writeHtmlReportToIframe(html);

      if (
        this.activatedRoute.snapshot.queryParams['openPdfDirectly'] == 'true' ||
        !this.reportDetails.AutoExportPDF
      ) {
        this.printGeneratedReport();
      }
    });
  }

  hasGeneratedReportContent() {
    return this.urlToShowInIframe !== '' || this.htmlToShowInIframe !== '';
  }

  writeHtmlReportToIframe(html: string) {
    const iframe = this.pdfAutoExportIframe
      ? this.pdfAutoExportIframe.nativeElement
      : null;
    const iframeDocument = iframe
      ? iframe.contentDocument || iframe.contentWindow.document
      : null;

    if (!iframeDocument) {
      this.messageService.warning('Report content is not ready to display.');
      return;
    }

    iframeDocument.open();
    iframeDocument.write(html);
    iframeDocument.close();
  }

  printGeneratedReport() {
    const iframe = this.pdfAutoExportIframe
      ? this.pdfAutoExportIframe.nativeElement
      : null;

    if (!iframe || !iframe.contentWindow) {
      this.messageService.warning('No report content is available to print.');
      return;
    }

    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  }

  base64ToArray(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  loadData(fromFilterChanged: boolean) {
    if (this.guid === '') {
      return;
    }

    const parametersToSend = this.getParametersToSend();
    this.isTableLoading = true;
    let filters: { [key: string]: SectionTableFilter };
    let pageSize = 30;
    let pageIndex = 1;

    if (this.tableSection !== undefined) {
      filters = this.tableSection.filters;
      pageSize = this.tableSection.pageSize;
      pageIndex = this.tableSection.pageIndex;

      console.log(this.tableSection.sortDirection);
      console.log(this.tableSection.sortField);
    } else {
      filters = {};
    }

    const localDataRetrieverCounter = ++this.dataRetrieverCounter;
    this.reportService
      .getReportData(
        this.reportId,
        parametersToSend,
        filters,
        pageSize,
        pageIndex - 1,
        this.guid,
        this.tableSection === undefined ||
          this.tableSection.sortDirection === undefined
          ? ''
          : this.tableSection.sortDirection,
        this.tableSection === undefined ||
          this.tableSection.sortField === undefined
          ? 0
          : this.tableSection.sortField,
      )
      .subscribe((data: any) => {
        if (localDataRetrieverCounter !== this.dataRetrieverCounter) {
          return;
        }

        console.log(
          'this.reportDetails.dataLoadedForFirstTime:' +
            this.reportDetails.dataLoadedForFirstTime,
        );
        this.totalRecords = data.length;
        this.dataTable.dataset = [...[], ...data.rowsArray];
        if (this.reportDetails.dataLoadedForFirstTime != true) {
          this.reportDetails.ColumnSettingsParsed = [
            ...[],
            ...data.columnSettings,
          ];

          this.reportDetails.dataLoadedForFirstTime = true;
        }
        this.isTableLoading = false;

        if (this.reportDetails.AutoExportPDF) {
          this.export('PdfHTML');
        }
      });
  }

  getParametersToSend() {
    const parametersToSend: { [key: string]: SectionTableFilter } = {};
    const parametersValues = this.reportParameters.parametersValues;
    this.reportParameters.parameters.forEach((reportParameter) => {
      const filter = new SectionTableFilter();
      if (
        reportParameter.DataType === ReportParameterDataType.Date &&
        parametersValues[reportParameter.FieldName] !== undefined
      ) {
        filter.singleValue = moment(
          parametersValues[reportParameter.FieldName],
        ).format(g.companyConfiguration.MomentDateFormat);
      } else {
        filter.singleValue = parametersValues[reportParameter.FieldName];
      }
      filter.filterType = this.reportService.getFilterTypeByParameterType(
        reportParameter.DataType,
      );

      parametersToSend[reportParameter.FieldName] = filter;
    });

    return parametersToSend;
  }
}
